import { render } from "./Requirements.vue?vue&type=template&id=e0b47f00&scoped=true"
import script from "./Requirements.vue?vue&type=script&lang=js"
export * from "./Requirements.vue?vue&type=script&lang=js"

import "./Requirements.vue?vue&type=style&index=0&id=e0b47f00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b47f00"]])

export default __exports__